<template>
  <v-card min-width="400px">
    <v-card-text>
      <v-row no-gutters>
        <v-col>
          <Avatar
            :size="24"
            font-class="text-xs"
            :first="user.userDetail?.firstName"
            :last="user.userDetail?.lastName"
            :seed="user.userDetail?.legacyId"
            :avatar-url="user.userDetail?.avatar"
          />
          <span class="pl-2 on-surface" v-text="`${user.userDetail?.firstName} ${user.userDetail?.lastName}`" />
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class="text-subheadgrey pl-8"
      >
        <span v-text="`${user.userDetail?.email}`" />
        <div class="flex-grow-1" />
        <v-tooltip
          location="top"
        >
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              color="primary"
              icon
              variant="text"
              size="x-small"
              class="mt-n2"
              @click.stop="onCopy"
            >
              <v-icon icon="mdi-content-copy" />
            </v-btn>
          </template>
          <span>Copy email address</span>
        </v-tooltip>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import Avatar from '@/components/common/Avatar/Avatar.vue'
import { useClipboard } from '@/composables/clipboard'

import type { User } from '@policyfly/protobuf/patrick'
import type { PropType } from 'vue'

export default defineComponent({
  name: 'UserInfoCard',

  components: {
    Avatar,
  },

  props: {
    user: { type: Object as PropType<User>, required: true },
  },

  setup (props) {
    const { copy } = useClipboard()

    function onCopy (): void {
      copy({ text: props.user.userDetail?.email ?? '', success: 'Email address has been copied.' })
    }

    return {
      onCopy,
    }
  },
})
</script>
